import { designActionTypes } from '../actions/types';

const changes = [];
let changesIndex = -1;

const initialState = {
  creating: false,
  designId: null,
  loading: false,
  name: null,
  width: null,
  height: null,
  pages: [],
  entitiesState: {},
  editorsState: {},
  svgsState: {},
  imagesState: {},
  selectedEntity: null,
  entityEditableMode: null,
  colorPickerColor: '#fff',
  imageColorsState: [],
  showFilterPanel: false,
  fontsLoaded: {},
  enabledEditorId: null,
  scale: 100,
  saving: false,
  saved: false,
  designs: [],
  designSkip: null,
  designLimit: 16,
  hasMoreDesign: true,
  exportState: null,
  exportLink: null,
  deleteState: null,
  spacingStyleClasses: {},
  listBlockStyleClasses: {},
  replaceEntity: false,
  fontSize: 30,
  designLoaded: false,
  selectedCategory: null,
  sourceTemplateId: null,
  educationContext: null,
};

export function design(state = initialState, action) {
  switch (action.type) {
    case designActionTypes.RESET_STATE:
      return {
        ...initialState,
      };
    case designActionTypes.CREATE_REQUEST:
      return {
        ...state,
        selectedCategory: action.category,
        designId: null,
        creating: true,
        designLoaded: false,
      };
    case designActionTypes.CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        designLoaded: true,
        designId: action.designId,
        name: action.name,
        width: action.width,
        height: action.height,
        pages: action.pages,
        entitiesState: action.entitiesState,
        editorsState: action.editorsState,
        svgsState: action.svgsState,
        fontsLoaded: action.fontsLoaded,
        sourceTemplateId: action.sourceTemplateId || null,
        educationContext: action.educationContext || null,
        saved: true,
      };
    case designActionTypes.CREATE_FAILURE:
      return {
        ...state,
        error: action.error,
        designId: null,
        creating: false,
        designLoaded: true,
      };
    case designActionTypes.DUPLICATE_REQUEST:
      return {
        ...state,
        duplicating: true,
      };
    case designActionTypes.DUPLICATE_SUCCESS:
      return {
        ...state,
        duplicating: false,
        designs: action.designs,
      };
    case designActionTypes.DUPLICATE_FAILURE:
      return {
        ...state,
        error: action.error,
        duplicating: false,
      };
    case designActionTypes.SAVE_REQUEST:
      return {
        ...state,
        saved: false,
        saving: true,
      };
    case designActionTypes.SAVE_SUCCESS:
      return {
        ...state,
        saved: action.saved !== false,
        saving: false,
      };
    case designActionTypes.SAVE_FAILURE:
      return {
        ...state,
        error: action.error,
        saved: false,
        saving: false,
      };
    case designActionTypes.SAVE_AS_TEMPLATE_REQUEST:
      return {
        ...state,
        saved: false,
        saving: true,
      };
    case designActionTypes.SAVE_AS_TEMPLATE_SUCCESS:
      return {
        ...state,
        saved: true,
        saving: false,
      };
    case designActionTypes.SAVE_AS_TEMPLATE_FAILURE:
      return {
        ...state,
        error: action.error,
        saved: false,
        saving: false,
      };
    case designActionTypes.SAVE_AS_TEXT_REQUEST:
      return {
        ...state,
        saved: false,
        saving: true,
      };
    case designActionTypes.SAVE_AS_TEXT_SUCCESS:
      return {
        ...state,
        saved: true,
        saving: false,
      };
    case designActionTypes.SAVE_AS_TEXT_FAILURE:
      return {
        ...state,
        error: action.error,
        saved: false,
        saving: false,
      };
    case designActionTypes.FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        designLoaded: false,
      };
    case designActionTypes.FETCH_SUCCESS:
      return {
        ...state,
        designId: action.designId,
        name: action.name,
        width: action.width,
        height: action.height,
        pages: action.pages,
        entitiesState: action.entitiesState,
        editorsState: action.editorsState,
        svgsState: action.svgsState,
        imagesState: action.imagesState,
        fontsLoaded: action.fontsLoaded,
        selectedCategory: action.category,
        sourceTemplateId: action.sourceTemplateId || null,
        educationContext: action.educationContext || null,
        loading: false,
        designLoaded: true,
        saved: true,
      };
    case designActionTypes.FETCH_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        designLoaded: true,
      };
    case designActionTypes.FETCH_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
        designLoaded: false,
      };
    case designActionTypes.FETCH_TEMPLATE_SUCCESS:
      return {
        ...state,
        name: action.name,
        width: action.width,
        height: action.height,
        pages: action.pages,
        entitiesState: action.entitiesState,
        editorsState: action.editorsState,
        svgsState: action.svgsState,
        imagesState: action.imagesState,
        fontsLoaded: action.fontsLoaded,
        loading: false,
        designLoaded: true,
        saved: true,
      };
    case designActionTypes.FETCH_TEMPLATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        designLoaded: true,
      };
    case designActionTypes.FETCH_TEXT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case designActionTypes.FETCH_TEXT_SUCCESS:
      return {
        ...state,
        name: action.name,
        width: action.width,
        height: action.height,
        pages: action.pages,
        entitiesState: action.entitiesState,
        editorsState: action.editorsState,
        svgsState: action.svgsState,
        imagesState: action.imagesState,
        fontsLoaded: action.fontsLoaded,
        loading: false,
        saved: true,
      };
    case designActionTypes.FETCH_TEXT_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case designActionTypes.ADD_PAGE:
      return {
        ...state,
        saved: false,
        pages: action.pages,
      };
    case designActionTypes.DELETE_PAGE:
      return {
        ...state,
        saved: false,
        pages: action.pages,
      };
    case designActionTypes.COPY_PAGE:
      return {
        ...state,
        saved: false,
        pages: action.pages,
        entitiesState: { ...state.entitiesState, ...action.entitiesState },
        editorsState: { ...state.editorsState, ...action.editorsState },
        svgsState: { ...state.svgsState, ...action.svgsState },
        imagesState: { ...state.imagesState, ...action.imagesState },
      };
    case designActionTypes.ADD_ENTITY:
      return {
        ...state,
        saved: false,
        pages: action.pages,
        entitiesState: { ...state.entitiesState, ...action.entitiesState },
        selectedEntity: action.selectedEntity ? action.selectedEntity : state.selectedEntity,
        enabledEditorId: action.enabledEditorId ? action.enabledEditorId : state.enabledEditorId,
      };
    case designActionTypes.DELETE_ENTITY:
      return {
        ...state,
        saved: false,
        pages: action.pages,
        entitiesState: action.entitiesState,
        selectedEntity: null,
        showFilterPanel: false,
        sidePanel: null,
      };
    case designActionTypes.ADD_EDITOR_STATE:
      return {
        ...state,
        saved: false,
        editorsState: { ...state.editorsState, ...action.state },
      };
    case designActionTypes.ADD_IMAGE_COLOR_STATE:
      return {
        ...state,
        imageColorsState: action.state,
      };
    case designActionTypes.ADD_SVG_STATE:
      return {
        ...state,
        saved: false,
        svgsState: { ...state.svgsState, ...action.state },
      };
    case designActionTypes.CHANGE_EDITOR_STATE:
      return {
        ...state,
        saved: action.saved,
        editorsState: { ...state.editorsState, ...action.newEditorState },
      };
    case designActionTypes.CHANGE_SVG_STATE:
      return {
        ...state,
        saved: false,
        svgsState: { ...state.svgsState, ...action.newSVGState },
      };
    case designActionTypes.CHANGE_ENTITY_STYLE:
      return {
        ...state,
        saved: false,
        pages: action.pages,
        entitiesState: { ...state.entitiesState, ...action.entityState },
      };
    case designActionTypes.CHANGE_GROUP_ENTITY_STYLE:
      return {
        ...state,
        saved: false,
        entitiesState: { ...state.entitiesState, ...action.newEntitiesState },
      };
    case designActionTypes.CHANGE_ENTITY_DATA:
      return {
        ...state,
        saved: false,
        pages: action.pages,
        entitiesState: { ...state.entitiesState, ...action.entityState },
      };
    case designActionTypes.CHANGE_SELECTED_ENTITY:
      return {
        ...state,
        selectedEntity: action.entity,
      };
    case designActionTypes.CHANGE_ENTITY_EDITABLE_MODE:
      return {
        ...state,
        entityEditableMode: action.entity,
      };
    case designActionTypes.CHANGE_COLOR_PICKER_COLOR:
      return {
        ...state,
        colorPickerColor: action.color,
      };
    case designActionTypes.CHANGE_SVG_COLOR:
      return {
        ...state,
        saved: false,
        entitiesState: { ...state.entitiesState, ...action.entityState },
        svgsState: { ...state.svgsState, ...action.svgState },
      };
    case designActionTypes.CHANGE_RECT_SELECTION:
      return {
        ...state,
        rectSelection: action.selectedEntities,
      };
    case designActionTypes.CHANGE_IMAGE_FILTER:
      return {
        ...state,
        saved: false,
        entitiesState: action.entitiesState,
      };
    case designActionTypes.SET_SIDE_PANEL:
      return {
        ...state,
        sidePanel: action.panel,
      };
    case designActionTypes.SHOW_FILTER_PANEL:
      return {
        ...state,
        showFilterPanel: action.show,
      };
    case designActionTypes.CHANGE_ENTITY_ARRANGE:
      return {
        ...state,
        saved: false,
        pages: action.pages,
      };
    case designActionTypes.CHANGE_IMAGE_STATE:
      return {
        ...state,
        saved: false,
        imagesState: { ...state.imagesState, ...action.newImageState },
      };
    case designActionTypes.LOAD_TEMPLATE_DESIGN:
      return {
        ...state,
        name: action.name,
        width: action.width,
        height: action.height,
        pages: action.pages,
        entitiesState: action.entitiesState,
        editorsState: action.editorsState,
        svgsState: action.svgsState,
        imagesState: action.imagesState,
        fontsLoaded: action.fontsLoaded,
        sourceTemplateId: action.sourceTemplateId || state.sourceTemplateId || null,
        educationContext: action.educationContext || state.educationContext || null,
        saved: action.saved,
      };
    case designActionTypes.LOAD_TEXT_DESIGN:
      return {
        ...state,
        entitiesState: action.entitiesState,
        editorsState: action.editorsState,
        fontsLoaded: action.fontsLoaded,
        saved: false,
      };
    case designActionTypes.ADD_FONT:
      return {
        ...state,
        fontsLoaded: action.fontsLoaded,
      };
    case designActionTypes.CHANGE_DESIGN_SIZE:
      return {
        ...state,
        saved: false,
        width: action.width,
        height: action.height,
      };
    case designActionTypes.CHANGE_ENABLE_EDITOR:
      return {
        ...state,
        enabledEditorId: action.editorId,
      };
    case designActionTypes.CHANGE_ENTITY_SRC:
      return {
        ...state,
        saved: false,
        pages: action.pages,
        entitiesState: action.entitiesState,
      };
    case designActionTypes.CHANGE_GRID_DATA:
      return {
        ...state,
        saved: false,
        entitiesState: { ...state.entitiesState, ...action.entityState },
      };
    case designActionTypes.CHANGE_FRAME_DATA:
      return {
        ...state,
        saved: false,
        entitiesState: action.entitiesState,
      };
    case designActionTypes.DELETE_PAGE_BACKGROUND_COLOR:
      return {
        ...state,
        saved: false,
        pages: action.pages,
      };
    case designActionTypes.DELETE_PAGE_BACKGROUND_MEDIA:
      return {
        ...state,
        saved: false,
        pages: action.pages,
      };
    case designActionTypes.DELETE_FRAME_MEDIA:
      return {
        ...state,
        saved: false,
        entitiesState: action.entitiesState,
      };
    case designActionTypes.CHANGE_PAGE_BACKGROUND_COLOR:
      return {
        ...state,
        saved: false,
        pages: action.pages,
      };
    case designActionTypes.CHANGE_PAGE_BACKGROUND_LOCK_STATE:
      return {
        ...state,
        saved: false,
        pages: action.pages,
      };
    case designActionTypes.CHANGE_DESIGN_PAGE_SCALE:
      return {
        ...state,
        scale: action.scale,
      };
    case designActionTypes.CHANGE_NAME:
      return {
        ...state,
        saved: false,
        name: action.name,
      };
    case designActionTypes.SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case designActionTypes.SEARCH_SUCCESS:
      return {
        ...state,
        designs: action.clear ? action.designs : [...state.designs, ...action.designs],
        designSkip: action.skip,
        designLimit: action.limit,
        hasMoreDesign: action.clear ? true : action.designs.length !== 0,
        loading: false,
      };
    case designActionTypes.SEARCH_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case designActionTypes.EXPORT_REQUEST:
      return {
        ...state,
        exportError: null,
        exportState: 'exporting',
        exportLink: null,
      };
    case designActionTypes.EXPORT_SUCCESS:
      return {
        ...state,
        exportError: null,
        exportState: 'success',
        exportLink: action.path,
      };
    case designActionTypes.EXPORT_FAILURE:
      return {
        ...state,
        exportError: action.error,
        exportState: 'failed',
      };
    case designActionTypes.DELETE_REQUEST:
      return {
        ...state,
        error: null,
        deleteState: 'request',
      };
    case designActionTypes.DELETE_SUCCESS:
      return {
        ...state,
        deleteState: 'success',
        designs: action.designs,
      };
    case designActionTypes.DELETE_FAILURE:
      return {
        ...state,
        error: action.error,
        deleteState: 'failure',
      };
    case designActionTypes.DUPLICATE_ENTITY:
      return {
        ...state,
        saved: false,
        pages: action.pages,
        entitiesState: action.entitiesState,
        imagesState: action.imagesState,
        svgsState: action.svgsState,
        editorsState: action.editorsState,
        selectedEntity: action.selectedEntity ? action.selectedEntity : state.selectedEntity,
      };
    case designActionTypes.ADD_SPACING_STYLE_CLASS:
      return {
        ...state,
        spacingStyleClasses: action.spacingStyleClasses,
      };
    case designActionTypes.ADD_LIST_BLOCK_STYLE_CLASS:
      return {
        ...state,
        listBlockStyleClasses: action.listBlockStyleClasses,
      };
    case designActionTypes.REPLACE_ENTITY_STATE:
      return {
        ...state,
        replaceEntity: action.replaceEntity,
      };
    case designActionTypes.SET_CURRENT_TEXT_INLINE_STYLE:
      return {
        ...state,
        fontSize: action.fontSize || state.fontSize,
        fontFamily: action.fontFamily || state.fontFamily,
        fontColor: action.fontColor || state.fontColor,
        inlineStyles: action.inlineStyles || state.inlineStyles,
        textBlockType: action.textBlockType || state.textBlockType,
        textAlignment: action.textAlignment || state.textAlignment,
        textTransform: action.textTransform || state.textTransform,
        letterSpacing: action.letterSpacing || state.letterSpacing,
        lineHeight: action.lineHeight || state.lineHeight,
      };
    case designActionTypes.CHANGE_LOCK_STATE:
      return {
        ...state,
        saved: false,
        entitiesState: action.entitiesState,
      };
    default:
      return state;
  }
}

export function addChanges(change) {
  // eslint-disable-next-line no-plusplus
  changesIndex++;
  changes.splice(changesIndex);
  changes[changesIndex] = change;
}

export function getUndo() {
  if (changesIndex === -1) return null;
  // eslint-disable-next-line no-plusplus
  return changes[changesIndex--].undo;
}

export function getRedo() {
  if (changes.length === changesIndex + 1) return null;
  // eslint-disable-next-line no-plusplus
  return changes[++changesIndex].redo;
}
